"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _articleListing = _interopRequireDefault(require("../../styles/article-listing.css"));
var _dateLabelContainer = _interopRequireDefault(require("../date-label-container"));
var _articleListing2 = _interopRequireDefault(require("../article-listing.props/article-listing.defaultProps"));
var _articleListing3 = require("../article-listing.props/article-listing.propTypes");
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString;
var getLinkData = function getLinkData(link) {
  return {
    url: renderEmptyString(link.url),
    label: renderEmptyString(link.label),
    priority: 'low'
  };
};
var NoImageLayout = function NoImageLayout(_ref) {
  var article = _ref.article,
    theme = _ref.theme,
    index = _ref.index,
    animated = _ref.animated;
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: index,
    className: theme.row + " " + theme.marginBottom80 + " " + _articleListing["default"].noImageWrapper + " " + (animated && _articleListing["default"].animated)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-md-3'] + " " + theme['col-md-offset-1']
  }, renderEmptyString(article.date) !== ' ' && /*#__PURE__*/_react["default"].createElement(_dateLabelContainer["default"], {
    date: article.date,
    theme: theme
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-md-7'] + " " + _articleListing["default"].layoutText
  }, renderEmptyString(article.articleInformation.sectionHeading) !== ' ' && /*#__PURE__*/_react["default"].createElement("h3", {
    className: theme.marginBottom20 + " " + theme.headingFour
  }, article.articleInformation.sectionHeading), renderEmptyString(article.articleInformation.link) !== ' ' && /*#__PURE__*/_react["default"].createElement("div", {
    className: _articleListing["default"].ctaWrapper
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: getLinkData(article.articleInformation.link)
  }))));
};
NoImageLayout.displayName = 'NoImageLayout';
NoImageLayout.defaultProps = {
  article: _articleListing2["default"].articles[0],
  index: 0,
  animated: false,
  theme: {}
};
var _default = NoImageLayout;
exports["default"] = _default;